import React from "react"; 
import FrameImage from "./FrameImage";

export default function Home() {

  // https://frames.go-globalschool.com/
  
  return (
    <>
      <FrameImage />
    </>
  );
}
